import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import brochure_bg from '../../assets/images/brochure_bg.webp';
// import MuiImageSlider from 'mui-image-slider';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import calcite from '../../assets/images/products/calcite.jpeg';
import calciumCarbonate from '../../assets/images/products/calcium-carbonate.jpg';
import calciumHydroxide from '../../assets/images/products/calcium-hydroxide.jpg';
import calciumOxide from '../../assets/images/products/calcium-oxide.jpg';
import dolomite from '../../assets/images/products/dolomite.jpeg';
import limeStone from '../../assets/images/products/lime-stone.jpg';



const settings = {
  dots: false,
  infinite: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  autoplay: false,
//   speed: 10000,
//   autoplaySpeed: 2000,
  // cssEase: "linear",

  // className: "center",
  // centerMode: true,
  // centerPadding: "60px",
  adaptiveHeight: true

  // dots: true,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 3
};



const ProductsSlider = () => {
  const { t, i18n } = useTranslation();
  return (
    <div>
    <h2 style={{color: 'rgb(154,74,32)', }}>{t('navigation.products')}</h2>
      <Box sx={{display:'flex', justifyContent: 'space-evenly', flexWrap:'wrap', gap: '20px', marginTop: '30px'}}>
        <div style={{ width: 400,}}>
          <img src={calcite} width={'100%'} height={250} style={{backgroundRepeat: 'no-repeat',objectFit: 'cover', borderRadius: '4px'}}/>
          <p style={{color: '#7f6001',}}>{t("calcite")}</p>
        </div>
        <div style={{ width: 400, }}>
        <img src={calciumCarbonate}  width={'100%'}  height={250} style={{backgroundRepeat: 'no-repeat',objectFit: 'cover', borderRadius: '4px'}}/>
        <p style={{color: '#7f6001',}}>{t('calciumCarbonate')}</p>
        </div>
        <div style={{ width: 400, }}>
        <img src={calciumHydroxide} width={'100%'}  height={250} style={{backgroundRepeat: 'no-repeat',objectFit: 'cover', borderRadius: '4px'}}/>
        <p style={{color: '#7f6001',}}>{t('calciumHydroxide')}</p>
       </div>
        <div style={{ width: 400, }}>
        <img src={calciumOxide} width={'100%'}  height={250} style={{backgroundRepeat: 'no-repeat',objectFit: 'cover', borderRadius: '4px'}}/>
        <p style={{color: '#7f6001',}}>{t('calciumOxide')}</p>
        </div>
        <div style={{ width: 400, }}>
        <img src={dolomite} width={'100%'}  height={250} style={{backgroundRepeat: 'no-repeat',objectFit: 'cover', borderRadius: '4px'}}/>
        <p style={{color: '#7f6001',}}>{t('dolomite')}</p>
        </div>
        <div style={{ width: 400, }}>
        <img src={limeStone} width={'98%'}  height={250} style={{backgroundRepeat: 'no-repeat',objectFit: 'cover', borderRadius: '4px'}}/>
        <p style={{color: '#7f6001',}}>{t('limestone')}</p>
        </div>
    </Box>
    </div>
  );
};

export default ProductsSlider;
